import { render, staticRenderFns } from "./users.template.vue?vue&type=template&id=92c93644&scoped=true&"
var script = {}
import style0 from "./users.template.vue?vue&type=style&index=0&id=92c93644&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c93644",
  null
  
)

export default component.exports